import React, { ReactElement } from 'react';
import { DrawerBody, Drawer } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { QueueStateProvider } from '../../queues/context/queue-state-provider';
import { FrUnitsList } from '../fr-units-list';
import { FrUnitsListHeader } from './fr-units-list-header';
import { useUnitQueueWorkspacePanel } from '../../common/hooks/use-unit-queue-workspace-panel';

export const FrUnitsListDrawer = observer(function FrUnitsListDrawer(): ReactElement {
    const workspacePanel = useUnitQueueWorkspacePanel();
    const drawerControls = useDrawerControls();

    return (
        <Drawer isOpen size="lg" onClose={drawerControls.close}>
            <QueueStateProvider workspacePanel={workspacePanel}>
                <FrUnitsListHeader />
                <DrawerBody>
                    <FrUnitsList compact />
                </DrawerBody>
            </QueueStateProvider>
        </Drawer>
    );
});

export type FrUnitsListDrawerType = typeof FrUnitsListDrawer;
